<template>
  <div class="padded padded">
    <h3><i class="fa fa-money-bill-alt" />&nbsp;Finance</h3>

    <el-tabs :tab-position="isDesktop ? 'left' : 'top'" :value="activeTab" @tab-click="onSubtabChange">

      <el-tab-pane name="tabSum">
        <template #label><span class="text-info"><i class="fa fa-globe text-muted"></i> Summary</span></template>

        <finance-summary :site-id="siteData.id" />
      </el-tab-pane>


      <el-tab-pane name="tabSharers" lazy>
        <template #label><span class="text-info"><i class="fa fa-users text-muted"></i> Sharers</span></template>

        <site-finance-sharers :row-data="siteData" :sharers="sharers" />
      </el-tab-pane>

      <el-tab-pane name="tabCont" lazy>
        <template #label><span class="text-info"><i class="fa fa-tools text-muted"></i> Contractors</span></template>

        <site-contractors :site-id="siteData.id" />
      </el-tab-pane>

      <el-tab-pane name="tabUtil" lazy>
        <template #label><span class="text-info"><i class="fa fa-plug text-muted"></i> Utilities</span></template>

        <site-util :row-data="siteData" :sharers="sharers" :subsubtab="subsubtab" />
      </el-tab-pane>


      <el-tab-pane name="tabProp" lazy>
        <template #label><span class="text-info"><i class="fa fa-home text-muted"></i> Property</span></template>

        <site-tenancy :row-data="siteData" />
      </el-tab-pane>

<!--
      <el-tab-pane label="Backhaul Payments" name="tab4">
        <site-finance-backhaul :row-data="siteData" />
      </el-tab-pane>
-->
    </el-tabs>

  </div>

</template>



<script>

import ArrayMixins from '@/mixins/ArrayMixins'
import SiteMixins from '@/mixins/SiteMixins'
import { replaceDrawerArgs } from '@/lib/layerNav'
import { parseDrawerPath, hasDrawer } from '@/lib/drawerParser'

import SiteContractors from '@/components/sites/finance/contractors/SiteContractors'

import FinanceSummary from '@/components/dashboard/views/FinanceSummary'
import SiteFinanceSharers from '@/components/sites/finance/SiteFinanceSharers'

import SiteTenancy from '@/components/sites/finance/tenancy/SiteTenancy'

import SiteUtil from '@/components/sites/utility/SiteUtil'


const SUBTAB_MAP = {
  summary: 'tabSum',
  sharers: 'tabSharers',
  contractors: 'tabCont',
  utilities: 'tabUtil',
  property: 'tabProp'
}

export default {
  mixins: [ArrayMixins, SiteMixins],

  components: {
    SiteContractors,
    SiteFinanceSharers,
    FinanceSummary,
    SiteTenancy,
    SiteUtil
  },

  props: {
    siteData: {
      type: Object,
      required: true
    },

    editMode: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    subtab: {
      type: String,
      default: null
    },

    subsubtab: {
      type: String,
      default: null
    }

  },

  computed: {
    activeTab () {
      return SUBTAB_MAP[this.subtab] || 'tabSum'
    }
  },

/*
  computed: {
    dueAdvance: function () {
      var res = 0

      if (this.summary.length > 0) {
        for (var i = 0, len = this.summary.length; i < len; i++) {
          if (this.summary[i].type === 'A' && this.summary[i].ledger === 'CR') {
            res += this.summary[i].total ? Number(this.summary[i].total) : 0
          }
        }
      }

      return this.formatMoney(res, 0)
    },

    dueSharing: function () {
      var res = 0

      if (this.summary.length > 0) {
        for (var i = 0, len = this.summary.length; i < len; i++) {
          if (this.summary[i].type === 'U' && this.summary[i].ledger === 'CR') {
            res += this.summary[i].total ? Number(this.summary[i].total) : 0
          }
        }
      }

      return this.formatMoney(res, 0)
    },

    dueFees: function () {
      var res = 0

      if (this.summary.length > 0) {
        for (var i = 0, len = this.summary.length; i < len; i++) {
          if (this.summary[i].type === 'L' && this.summary[i].ledger === 'CR') {
            res += this.summary[i].total ? Number(this.summary[i].total) : 0
          }
        }
      }

      return this.formatMoney(res, 0)
    },

    paid: function () {
      var res = 0

      if (this.summary.length > 0) {
        for (var i = 0, len = this.summary.length; i < len; i++) {
          if (this.summary[i].type === 'L' && this.summary[i].ledger === 'CR') {
            res += this.summary[i].totalPaid ? Number(this.summary[i].totalPaid) : 0
          }
        }
      }

      return this.formatMoney(res, 0)
    }

  },
*/

  methods: {

    fetchSharers (data) {
      this.sharers = data
    },

    onSubtabChange (tabPane) {
      const slug = Object.keys(SUBTAB_MAP).find(k => SUBTAB_MAP[k] === tabPane.name) || null
      // Check current subtab from drawer stack (new grammar) or route params (legacy)
      const currentSubtab = this._currentSubtab()
      if ((currentSubtab || null) === (slug || null)) return
      replaceDrawerArgs(this.$router, 'site', { subtab: slug, subsubtab: null })
    },

    // Returns the current subtab from whichever routing mode is active.
    _currentSubtab () {
      const path = this.$route && this.$route.path ? this.$route.path : ''
      const idx = path.indexOf('/d.')
      if (idx !== -1) {
        const stack = parseDrawerPath(path.slice(idx + 1))
        const entry = stack.find(e => e.name === 'site')
        return entry ? (entry.args.subtab || null) : null
      }
      // Legacy fallback
      return this.$route && this.$route.params ? (this.$route.params.subtab || null) : null
    },

    // When this component mounts on a tab URL without an explicit subtab,
    // push the resolved default slug into the URL so bookmarks / shared links
    // are self-describing. onSubtabChange's same-slug guard suppresses a
    // duplicate replace if the URL already has the right segment.
    syncDefaultSubtab () {
      const path = this.$route && this.$route.path ? this.$route.path : ''
      const inDrawerStack = path.indexOf('/d.') !== -1
      if (inDrawerStack) {
        const stack = parseDrawerPath(path.slice(path.indexOf('/d.') + 1))
        if (hasDrawer(stack, 'site') && !this._currentSubtab()) {
          this.onSubtabChange({ name: this.activeTab })
        }
      }
    }

  },



  data () {
    return {
      editing: this.editMode,
      canEdit: this.canAccess('finance') && this.isManager(),
      localSite: this.siteData,
      sharers: [],
      summary: [],
      showDialog: false,
      outstanding: 0,
      agreement: null
    }
  },

  created () {
    this.findSiteSharers(this.siteData.id, this.fetchSharers)
  },

  mounted () {
    // $nextTick: let any lazy parent tab finish mounting before pushing the
    // default-subtab URL. Without this, syncDefaultSubtab can fire before
    // route reactivity settles and the URL self-append fails silently.
    this.$nextTick(this.syncDefaultSubtab)
  }

}
</script>
